import React from 'react';
import { Typography } from '@mui/material';

interface PatientInfoTextProps {
  firstText?: string;
  secondText?: string;
}

const PatientInfoText: React.FC<PatientInfoTextProps> = ({ firstText, secondText }) => {
  return (
    <div className="p-1">
      <Typography
        variant="body1"
        sx={{
          fontSize: '14px',
          fontWeight: 700,
          lineHeight: '20px',
          letterSpacing: '0em',
          textAlign: 'left',
        }}
      >
        {firstText}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '20px',
          letterSpacing: '0em',
          textAlign: 'left',
        }}
      >
        {secondText}
      </Typography>
    </div>
  );
};

export default PatientInfoText;
